import { render, staticRenderFns } from "./AutomationSettingsForm.vue?vue&type=template&id=ca8e542c"
import script from "./AutomationSettingsForm.vue?vue&type=script&lang=js"
export * from "./AutomationSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports